export default __webpack_public_path__ + "static/media/Stock_Graph.e2e3c80b.png";